import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import { Button, Table } from "react-bootstrap";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { FaFilter } from "react-icons/fa";
import ChartComponent from "../FixedReportChart";
import FilterPannel from "../../filter/FilterPannel";
import moment from "moment";


class CompletedCallReport extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model)
    const userOptions = model.user.options|| [];
    this.fields = model.call.fields;
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;
    this.state = {
      progressData: [],
      userOptions,
      filters: [{
        field: "responsible_person",
        condition: "in",        
        value: `~${this.loggedInUserId}~`,
      }, {
        "field": "complete",
        "condition": "not-in",
        "value": ""
      },{
        "field": "date_time",
        "condition": "in",
        "value": `${moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')}~${moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')}`
      }],
      dataSums:[],
      totalSum:0,
      inApiCall: false,
      isFilterOpen: true,
      exportData: [],
    };
  }

  componentDidMount(l) {
    this.fetchApi(this.state.filters,this.onSuccess, this.onFail);
  }


 fetchApi = (filters,onSuccess, onFail) => {
    const body = {
      filters : filters,
      model: "call_model",
      x:"responsible_person",
      y:"",
      z:"COUNT(cl.id)"
    }
    this.setState({inApiCall: true})
    DailySalesReportAPI.getFixedReport(body, onSuccess, onFail);
  };


  onSuccess =(data)=>{
    const exportData = data.map(this.mapDataForExport);
    // creating blank object and filling 0 to each progress index
    const dataSums = this.state.userOptions.reduce((sums, option) => {
      sums[option.value] = 0;
      return sums;
    }, {});
    // inserting data in specific progress id 
    data.forEach((item) => {
      if (dataSums[item.responsible_person] !== undefined) {
        dataSums[item.responsible_person] = item.sum;
      }
    });

    const totalSum = Object.values(dataSums).filter(Boolean).reduce((total, value) => total + value, 0);
    this.setState({ exportData ,dataSums , totalSum , inApiCall: false  });
  }

  onFail = (err) =>{
    console.log("Failed to fetch data" , err);
  }

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters },    
     this.fetchApi(this.state.filters,this.onSuccess, this.onFail));
  };

   mapDataForExport = (item) => ({
        user: this.state.userOptions.find((option) => option.value === item.responsible_person)?.label || "Unknown",
        Total: item.sum,
      });
    

render(){
const {exportData , filters ,isFilterOpen , inApiCall , dataSums ,totalSum, userOptions} = this.state;
let selectedUserId ,filteredUserOptions;
this.state.filters.map(filter => filter.field === 'responsible_person' ?  selectedUserId = filter.value.split(Constants.Opt).filter(Boolean) : null);
filteredUserOptions = this.state.userOptions.filter(user => { 
  if (Boolean(selectedUserId)) {
    return selectedUserId?.some(id => parseInt(id) === user.value);
  }
  return true;
});

  const table = (
  <Table striped bordered hover>
    <thead>
      <tr>
        <th>user</th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      {filteredUserOptions.map((option, index) => (
        <tr key={index}>
          <td>{option.label}</td>
          <td>{dataSums[option.value]}</td>
        </tr>
      ))}
      <tr>
        <td>
          <strong>Total</strong>
        </td>
        <td>
          <strong>{totalSum}</strong>
        </td>
      </tr>
    </tbody>
  </Table>);

return (
      <ApiUiController inApiCall={inApiCall}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-6">
                <h1>Completed Call Report</h1>
              </div>
              <div className="col-md-6">
                  <CSVLink data={exportData} filename={`completed_call_report.csv`}>
                  <Button className="buttons btn-success">Export</Button>
                </CSVLink>
              </div>
            </div>
          </div>
          <div className="col-md-4 pt-1">
            <div className="row filterrow">
              <div className="col-md-12 lastcol">
                <div className="m-right">
                  <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                    <FaFilter />
                    <span className="badge badge-danger badge-mini rounded-circle">
                      {this.state.filters.length}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                <ChartComponent
                  progressSums={dataSums}
                  progressOptions={userOptions}
                  type="pie"
                />
                <div className="col-md-12">{table}</div>
              </div>
              {this.state.isFilterOpen && (
                <FilterPannel
                  filters={filters}
                  fields={this.fields}
                  onFilterChange={this.onFilterChange}
                  isFilterOpen={isFilterOpen}
                  restrict={false}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </ApiUiController>)


}
}


export default CompletedCallReport;

